import Vue from 'vue'
import axios from 'axios';

export default {
    state: {
        user: {},
        shifts_cancelled: [],
        extra_request: [],
        shifts_charge_removed: [],
        shifts_inactive_fee: [],
        period_date_from: void 0,
        period_date_to: void 0,
        promisesStatus: {},
    },
    mutations: {
        fetchShiftCancelled(state, { payload, period_date_from, period_date_to}) {
            state.shifts_cancelled = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        fetchShiftsExtraRequest(state, { payload, period_date_from, period_date_to}) {
            state.extra_request = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        fetchShiftsChargeRemoved(state, { payload, period_date_from, period_date_to}) {
            state.shifts_charge_removed = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        fetchShiftsInactiveFee(state, { payload, period_date_from, period_date_to}) {
            state.shifts_inactive_fee = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        //Clear the list when date interval changes
        clearStates(state, payload) {
            const params = Array.isArray(payload.params) ? payload.params : [payload.params];
            params.forEach(param => {
                if (state[param.id] && Array.isArray(state[param.id])) {
                  state[param.id] = [];
                  //this.state.drivers.promisesStatus[param] = false;
                } else {
                  console.error(`State property ${param} is not an array or does not exist.`);
                }
            });
        }
    },
    actions: {
        async fetchShiftCancelled({ commit, dispatch }, {period_date_from, period_date_to}) {
            let promiseName = 'shifts_cancelled';
            //if (!this.state.drivers.promisesStatus[promiseName]) {
                commit('clearError')
                commit('setLoading', true);
                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/reporting/shiftsCancelled?period_date_from=${period_date_from}&period_date_to=${period_date_to}`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchShiftCancelled',  { payload: data, period_date_from, period_date_to });
                    //commit('setPromiseStatus', { promiseName: promiseName, status: true });
                } catch(error) {
                    commit('setLoading', false);
                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }
                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            //}
        },
        async fetchShiftsExtraRequest({ commit, dispatch }, {period_date_from, period_date_to}) {
            let promiseName = 'extra_request';
            //if (!this.state.drivers.promisesStatus[promiseName]) {
                commit('clearError')
                commit('setLoading', true);
                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/reporting/extraRequest?period_date_from=${period_date_from}&period_date_to=${period_date_to}`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchShiftsExtraRequest', {payload: data, period_date_from, period_date_to});
                    //commit('setPromiseStatus', { promiseName: promiseName, status: true });
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
            //}
        },
        async fetchShiftsChargeRemoved({ commit, dispatch }, {period_date_from, period_date_to, extra_request}) {
                commit('clearError')
                commit('setLoading', true);
                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/reporting/chargeRemoved?period_date_from=${period_date_from}&period_date_to=${period_date_to}&extra_request=${extra_request}`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchShiftsChargeRemoved', {payload: data, period_date_from, period_date_to});
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
        },
        async fetchShiftsInactiveFee({ commit, dispatch }, {period_date_from, period_date_to}) {
                commit('clearError')
                commit('setLoading', true);
                let user = JSON.parse(localStorage.getItem("user"));
                try {
                    let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/timesheet/inactiveFee?period_date_from=${period_date_from}&period_date_to=${period_date_to}`, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            "Authorization": `Bearer ${user.access_token}`
                        }
                    });

                    commit('setLoading', false);
                    commit('fetchShiftsInactiveFee', {payload: data, period_date_from, period_date_to});
                } catch(error) {
                    commit('setLoading', false);

                    if (error.response) {
                        let errors = error.response;
                        if (errors.status == 401) {
                            dispatch('logOutUser');
                            window.location.reload();
                        }
                        if(errors.status == 400) {
                            dispatch('setError', _.values(errors.data)[0][0]);
                            return Promise.reject(errors.data);
                        }
                    }

                    if (error.message) {
                        dispatch('setError', error.message);
                    } else {
                        dispatch('setError', error);
                    }
                }
        },
    },
    getters: {
        extra_request(state) {
            return state.extra_request;
        },
        shifts_cancelled(state) {
            return state.shifts_cancelled;
        },
        shifts_charge_removed(state) {
            return state.shifts_charge_removed;
        },
        shifts_inactive_fee(state) {
            return state.shifts_inactive_fee;
        },
    }
}